<app-user-mountpoint [pageTitle]="'RTK Base Analyzer (Basic Edition)'" [showDetails]="false" [showMap]="false" [showSnr]="false" [showDownloader]="false" [showAnalyzer]="true" [showAddDelButtons]="false" [showGetInfoButton]="false" [autoShowFullAnalysis]="true" [isAnalyzerPage]="true" [showPaginationNav]="false"></app-user-mountpoint>


